<template>

</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
    name: "Logout",
    mounted() {
        this.logout()
    },
    methods: {
        async logout () {
            const token = this.$cookies.get('token');
            await axios.get('/api/logout', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$cookies.remove('token');
                    this.$cookies.remove('shared_token', null, '.arkadia.me');
                    // Handle login sso
                    this.handleSso(response.data.url);
                    //
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    this.$router.replace({name: 'login'});
                })
                .catch((error) => {
                    this.$cookies.remove('token');
                    this.$cookies.remove('shared_token', null, '.arkadia.me');
                    this.$router.replace({name: 'login'});
                });
        },
        handleSso(url) {
            url.forEach((item) => {
                $.getScript(item.url.toString())
                    .done(( script, textStatus ) => {
                        // totalRun = totalRun +1
                        // console.log(textStatus)
                    })
                    .fail(( jqxhr, settings, exception ) => {
                        // totalRun = totalRun +1
                    });
            });
        }
    }
}
</script>

<style scoped>

</style>
